/**
 * Safe localStorage helpers with user-visible failure reporting.
 */

let lastWarning = { message: '', ts: 0 };
const WARNING_COOLDOWN_MS = 4000;

function emitStorageWarning(message) {
  const now = Date.now();
  if (lastWarning.message === message && now - lastWarning.ts < WARNING_COOLDOWN_MS) return;
  lastWarning = { message, ts: now };
  window.dispatchEvent(new CustomEvent('unveil:storage-warning', { detail: { message } }));
}

export function safeGetItem(key, fallback = '') {
  try {
    const value = localStorage.getItem(key);
    return value ?? fallback;
  } catch {
    return fallback;
  }
}

export function safeReadJSON(key, fallback) {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : fallback;
  } catch {
    return fallback;
  }
}

export function safeSetItem(key, value, message = 'Local storage is full. New data could not be saved.') {
  try {
    localStorage.setItem(key, value);
    return true;
  } catch {
    emitStorageWarning(message);
    return false;
  }
}

export function safeRemoveItem(key, message = 'Local storage could not be updated.') {
  try {
    localStorage.removeItem(key);
    return true;
  } catch {
    emitStorageWarning(message);
    return false;
  }
}
